var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type_mapped === "territorio"
        ? [
            _c(
              "b-container",
              { staticClass: "scroll" },
              [
                _vm.type === "zona_gn"
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Código Zona" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        value:
                                          _vm.feature.properties.codigo_zona_gn,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Nombre Zona" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        value:
                                          _vm.feature.properties.nombre_zona_gn,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "provincia"
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Código provincia" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        value:
                                          _vm.feature.properties
                                            .codigo_provincia_ine,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Nombre provincia" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        value:
                                          _vm.feature.properties
                                            .nombre_provincia_ine,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "codigo_postal"
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "4" } },
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Código postal" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        value:
                                          _vm.feature.properties.codigo_postal,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "municipio"
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código municipio" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .codigo_municipio_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Nombre municipio" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_municipio_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Nombre provincia" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_provincia_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Municipio NEDGIA" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.municipio_gnd,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código provincia" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .codigo_provincia_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box", staticStyle: { "margin-top": "0px" } },
                  [
                    _c(
                      "b-row",
                      _vm._l(_vm.territorio_columns, function(element) {
                        return _c("b-col", { key: element }, [
                          _c("strong", [_vm._v(_vm._s(element))])
                        ])
                      })
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.territorio, function(row, index) {
                      return _c(
                        "b-row",
                        { key: index },
                        _vm._l(_vm.territorio_columns, function(
                          element,
                          index2
                        ) {
                          return _c(
                            "b-col",
                            { key: index2 },
                            [
                              row[index2]
                                ? _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _vm._v(_vm._s(row[index2].title))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "text-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.toSpanish(
                                                _vm.feature.properties[
                                                  row[index2].value
                                                ]
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-row",
                                    [_c("b-col"), _vm._v(" "), _c("b-col")],
                                    1
                                  )
                            ],
                            1
                          )
                        })
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("strong", [_vm._v("Resumen Longitud Red")])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col"),
                        _vm._v(" "),
                        _c("b-col", [_c("strong", [_vm._v("Distribución")])]),
                        _vm._v(" "),
                        _c("b-col"),
                        _vm._v(" "),
                        _c("b-col", [_c("strong", [_vm._v("Alta Presión")])])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col"),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_c("strong", [_vm._v("GN")])]),
                                _vm._v(" "),
                                _c("b-col", [_c("strong", [_vm._v("GP")])])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col"),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_c("strong", [_vm._v("GN")])]),
                                _vm._v(" "),
                                _c("b-col", [_c("strong", [_vm._v("GP")])])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("En servicio (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_distribucion_gn_enservicio
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_distribucion_gp_enservicio
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("En servicio (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_transporte_gn_enservicio
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_transporte_gp_enservicio
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("No abandonada (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_distribucion_gn_noabandonada
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_distribucion_gp_noabandonada
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("No abandonada (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_transporte_gn_noabandonada
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_transporte_gp_noabandonada
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("Total (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_gn_distribucion
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_gp_distribucion
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("Total (m)")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_gn_transporte
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .longitud_red_gp_transporte
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("strong", [_vm._v("Resumen Acometidas")])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col"),
                        _vm._v(" "),
                        _c("b-col", [_c("strong", [_vm._v("Distribución")])]),
                        _vm._v(" "),
                        _c("b-col"),
                        _vm._v(" "),
                        _c("b-col", [_c("strong", [_vm._v("Alta Presión")])])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col"),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_c("strong", [_vm._v("GN")])]),
                                _vm._v(" "),
                                _c("b-col", [_c("strong", [_vm._v("GP")])])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col"),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_c("strong", [_vm._v("GN")])]),
                                _vm._v(" "),
                                _c("b-col", [_c("strong")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("En servicio")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_distribucion_enservicio
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gp_distribucion_enservicio
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("En servicio")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_transporte_enservicio
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("No abandonada")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_distribucion_noabandonada
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gp_distribucion_noabandonada
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("No abandonada")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_transporte_noabandonada
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [_vm._v("Total")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_distribucion
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gp_distribucion
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", [_vm._v("Total")]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.toSpanish(
                                        _vm.feature.properties
                                          .total_acometidas_gn_transporte
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "red"
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "IDI" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.id.split(".")[1],
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Provincia" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_provincia_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Municipio" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_municipio_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.red, function(row, index) {
              return _c(
                "b-row",
                { key: index },
                _vm._l(row, function(col, index) {
                  return _c(
                    "b-col",
                    { key: index },
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: col.title }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  value: _vm.feature.properties[col.value],
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            })
          ]
        : _vm.type_mapped === "mun_red_desplazada"
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        staticStyle: { "font-size": "1rem" },
                        attrs: { label: "Código municipio" }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            value: _vm.feature.properties.codigo_municipio_ine,
                            disabled: ""
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        staticStyle: { "font-size": "1rem" },
                        attrs: { label: "Nombre municipio" }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            value: _vm.feature.properties.nombre_municipio_ine,
                            disabled: ""
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        staticStyle: { "font-size": "1rem" },
                        attrs: { label: "Nombre provincia" }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            value: _vm.feature.properties.nombre_provincia_ine,
                            disabled: ""
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        staticStyle: { "font-size": "1rem" },
                        attrs: { label: "Código provincia" }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            value: _vm.feature.properties.codigo_provincia_ine,
                            disabled: ""
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "territorio_gn"
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código provincia" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.codigo_provincia_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Provincia" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_provincia_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.type != "nucleo_urbano"
                  ? _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.tipo,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código municipio" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.codigo_municipio_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Municipio" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_municipio_ine,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.type != "nucleo_urbano"
                  ? _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Denominación" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.denominacion,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm.type_mapped === "comercial" || _vm.type_mapped === "caldera"
        ? [
            _vm.errors.any("alta") ||
            _vm.errors.any("identificacion") ||
            _vm.errors.any("cambios_identificacion") ||
            _vm.errors.any("gestion")
              ? _c("div", { staticClass: "mb-3" }, [
                  _c("strong", { staticStyle: { color: "red" } }, [
                    _vm._v("¡Atención!")
                  ]),
                  _vm._v(" "),
                  _vm.errors.any("identificacion")
                    ? _c("div", [_vm._m(0)])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.any("alta") ? _c("div", [_vm._m(1)]) : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.any("cambios_identificacion")
                    ? _c("div", [_vm._m(2)])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.any("gestion") ? _c("div", [_vm._m(3)]) : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _vm.newComercial
                  ? _c(
                      "b-tab",
                      {
                        attrs: {
                          title: "Alta establecimiento",
                          active: _vm.newComercial
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "scroll" },
                          [
                            _c("NewComercial", {
                              ref: "saveTab",
                              attrs: {
                                feature: _vm.feature,
                                type: _vm.type_mapped,
                                permisos: _vm.permisos
                              },
                              on: { save: _vm.saveComercial, close: _vm.close }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.newComercial
                  ? _c(
                      "b-tab",
                      {
                        attrs: {
                          title: "Identificación",
                          active: !_vm.newComercial
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "scroll" },
                          [
                            _c("ComercialId", {
                              ref: "identificacionTab",
                              attrs: {
                                feature: _vm.feature,
                                type: _vm.type_mapped,
                                permisos: _vm.permisos
                              },
                              on: {
                                triggerComercialSave: _vm.triggerComercialSave,
                                calderaSaved: _vm.calderaSaved,
                                comercialSaved: _vm.comercialSaved
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.newComercial
                  ? _c(
                      "b-tab",
                      { attrs: { title: "Cambios identificación" } },
                      [
                        _c(
                          "div",
                          { staticClass: "scroll" },
                          [
                            _vm.type_mapped === "caldera"
                              ? [
                                  _c("br"),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "Esta caldera está en ZEUS, solicitar cambios de identificación a través de Altas Potenciales."
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              : _vm.feature.properties
                                  .id_tipo_establecimiento_gn_comercial.id ===
                                349
                              ? [
                                  _c("br"),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "Este comercial está en ZEUS, solicitar cambios de identificación a través de Altas Potenciales."
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              : [
                                  !_vm.loading_comercial
                                    ? _c("ComercialCambios", {
                                        ref: "cambios",
                                        attrs: {
                                          permisos: _vm.permisos,
                                          modification: _vm.modification
                                        },
                                        on: {
                                          triggerComercialSave:
                                            _vm.triggerComercialSave,
                                          close: _vm.close,
                                          changeLocation: _vm.changeLocation,
                                          getLocation: _vm.getLocation,
                                          SetNewLocation: _vm.SetNewLocation,
                                          comercialSaved: _vm.comercialSaved
                                        }
                                      })
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("b-tab", { attrs: { title: "Gestión" } }, [
                  _c(
                    "div",
                    [
                      _c("ComercialGestion", {
                        ref: "gestionTab",
                        attrs: {
                          "data-vv-scope": "university",
                          newComercial: _vm.newComercial,
                          feature: _vm.feature,
                          type: _vm.type_mapped,
                          permisos: _vm.permisos
                        },
                        on: {
                          triggerComercialSave: _vm.triggerComercialSave,
                          calderaSaved: _vm.calderaSaved,
                          comercialSaved: _vm.comercialSaved,
                          save: _vm.saveComercial,
                          close: _vm.close
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.type_mapped === "caldera"
                  ? _c("b-tab", { attrs: { title: "Info adicional" } }, [
                      _c(
                        "div",
                        { staticClass: "scroll" },
                        [
                          _c("InfoAdicional", {
                            attrs: {
                              feature: _vm.feature,
                              type: _vm.type_mapped,
                              permisos: _vm.permisos
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.newComercial
                  ? _c("b-tab", { attrs: { title: "Visitas" } }, [
                      _c(
                        "div",
                        { staticClass: "scroll" },
                        [
                          _c("ComercialVisitas", {
                            attrs: {
                              feature: _vm.feature,
                              permisos: _vm.permisos,
                              type: _vm.type_mapped
                            },
                            on: {
                              calderaSaved: _vm.calderaSaved,
                              comercialSaved: _vm.comercialSaved
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.newComercial
                  ? _c("b-tab", { attrs: { title: "Multimedia" } }, [
                      _c(
                        "div",
                        { staticClass: "scroll" },
                        [
                          _c("ComercialMultimedia", {
                            attrs: {
                              feature: _vm.feature,
                              permisos: _vm.permisos,
                              type: _vm.type_mapped
                            },
                            on: {
                              calderaSaved: _vm.calderaSaved,
                              comercialSaved: _vm.comercialSaved
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm.type_mapped === "acometida"
        ? [
            _c(
              "div",
              { staticStyle: { width: "95%" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "IDI" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.id.split(".")[1],
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código acometida" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.codacom,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código cliente" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.codcliente,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Provincia" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_provincia_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Municipio" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_municipio_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Población" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { value: "-", disabled: "" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Status" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .amp_status_acometida,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Diámetro" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.diametro,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Material" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.material,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo red" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.amp_tipo_red,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo gas" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.amp_tipo_gas,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Propiedad" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.amp_propiedad,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Distribuidora" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties.amp_distribuidora,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código obra alta" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.obraalta,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código obra baja" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.obrabaja,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "planta_gasificacion"
        ? [
            _c(
              "div",
              { staticStyle: { width: "95%" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "IDI" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.id.split(".")[1],
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código planta" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.codigo_planta,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Provincia" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_provincia_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Municipio" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_municipio_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Población" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { value: "-", disabled: "" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Descripción" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.descripcion,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Status operativo" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties.status_operativo,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Propiedad" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.propiedad,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Distribuidora" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { value: "-", disabled: "" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo planta" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.tipo_planta,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo instalación" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties.tipo_instalacion,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo mercado" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.tipo_mercado,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Núm. depósitos" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.n_depositos,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Núm. usuarios activo" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties.n_usuarios_activos,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Latitud" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.latitud,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Longitud" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.longitud,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "gasinera"
        ? [
            _c(
              "div",
              { staticStyle: { width: "95%" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "IDI" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.id.split(".")[1],
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Provincia" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_provincia_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Municipio" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .nombre_municipio_ine,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Población" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { value: "-", disabled: "" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Dirección" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.direccion,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código postal" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.codigo_postal,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Denominación" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.denominacion,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Estado" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.estado,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Propiedad" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.propiedad,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Fecha apertura" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties.fecha_de_apertura,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Latitud" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.latitud,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Longitud" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value: _vm.feature.properties.longitud,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo combustible" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .tipo_de_combustible,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "residencial"
        ? [
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { staticClass: "mt-1", attrs: { title: "Identificación" } },
                  [
                    _c(
                      "div",
                      { staticClass: "scroll" },
                      [
                        _c("ResidencialIdentificacion", {
                          attrs: { feature: _vm.feature }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { staticClass: "mt-3", attrs: { title: "Resumen" } },
                  [
                    _c(
                      "div",
                      { staticClass: "scroll" },
                      [
                        _c("ResidencialResumen", {
                          attrs: { feature: _vm.feature }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { staticClass: "mt-3", attrs: { title: "Info Adicional" } },
                  [
                    _c(
                      "div",
                      { staticClass: "scroll" },
                      [
                        _c("residencial-info-adicional", {
                          attrs: { feature: _vm.feature }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "catastro"
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        staticStyle: { "font-size": "1rem" },
                        attrs: { label: "Referencia catastral" }
                      },
                      [
                        _c("b-form-input", {
                          attrs: { value: _vm.feature.code, disabled: "" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mt-4",
                        attrs: {
                          size: "lg",
                          href: _vm.feature.url,
                          target: "_blank"
                        }
                      },
                      [_vm._v("Ver")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.type_mapped === "seccion_censal"
        ? [
            _c(
              "div",
              { staticStyle: { width: "95%" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "4" } },
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código sección censal" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    value:
                                      _vm.feature.properties
                                        .codigo_seccion_censal,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box", staticStyle: { "margin-top": "0px" } },
                  [
                    _c(
                      "b-row",
                      _vm._l(_vm.territorio_columns, function(element) {
                        return _c("b-col", { key: element }, [
                          _c("strong", [_vm._v(_vm._s(element))])
                        ])
                      })
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.territorio, function(row, index) {
                      return _c(
                        "b-row",
                        { key: index },
                        _vm._l(_vm.territorio_columns, function(
                          element,
                          index2
                        ) {
                          return _c(
                            "b-col",
                            { key: index2 },
                            [
                              row[index2]
                                ? _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _vm._v(_vm._s(row[index2].title))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "text-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.toSpanish(
                                                _vm.feature.properties[
                                                  row[index2].value
                                                ]
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-row",
                                    [_c("b-col"), _vm._v(" "), _c("b-col")],
                                    1
                                  )
                            ],
                            1
                          )
                        })
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _vm._v("Hay errores en la pestaña "),
      _c("b", [_vm._v("Identificación")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _vm._v("Hay errores en la pestaña "),
      _c("b", [_vm._v("Alta establecimiento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _vm._v("Hay errores en la pestaña "),
      _c("b", [_vm._v("Cambios Identificación")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "red" } }, [
      _vm._v("Hay errores en la pestaña "),
      _c("b", [_vm._v("Gestión")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details.vue?vue&type=template&id=0a36f772&scoped=true&
// module id = null
// module chunks = 